angular.module('cvsApp').service('enrollNonPatientService',['networkService', 'xdrService', 'configManager', 'commonModel', function (NS, XS,CM, CMOD) {
   	
	function enrollNonPatientService (){
		var self = this;
		this.enrollNonPatient = function(data,captchaToken, callBackSuccess){
			//get url 
			var url = CM.getApiUrlWithApikeyAndCaptcha('ENROLL_NP',captchaToken);
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{},
							data:getRequestBody(data),
							onSuccess:callBackSuccess
						}

				cvsUtility.commonServiceCode(url,"enrollNonPatient",self,request,callBackSuccess,NS);	
			}
						
		}

		var getRequestBody = function(data){
			resp.widgetSource = 'Registration';
			var requestJson =	{
				enrollNonPatientRequest: resp
			}
			return cvsUtility.JSONToXml(requestJson);
		}

		var resp = {
			dataEntryType: 'SELF',
			patientData: {},
			careTakerData: {},
			medicationDescription: '',
			physicianDetails: {},
			insuranceInformation: {
				medBTransplantFlag: undefined,
				primaryInsurance: {
					selected: 'Y',
					cardHolderInformation: {}
				},
				secondaryInsurance: {
					selected: 'Y',
					cardHolderInformation: {}
				},
				insuranceAcknowledgment: 'N'
			},
			callMeAnyTimeFlag: 'Y',
			choseADayDetails: {
				mon: 'N',
				tues: 'N',
				wed: 'N',
				thurs: 'N',
				fri: 'N'
			},
			choseTime: {
				morning: 'N',
				afternoon: 'N',
				evening: 'N'
			}
		};
		var state = '';
		this.setData = function(data){
			resp = data;			
		}	

		this.getData = function(){				
			return resp;
		}

		this.setState = function(data){
			state = data;			
		}	

		this.getState = function(){				
			return state;
		}
		
		this.setResponse = function(data){
			CMOD.setResponse(data);			
		}	

		this.getResponse = function(){				
			return CMOD.getCommonResponse();		
		}
	}
	
	return new enrollNonPatientService();	
}]);
